import { createGlobalStyle, theme } from '@notino/react-styleguide-v20';

export const GlobalStyle = createGlobalStyle`
  *, *:before, *:after {
    margin: 0;
    padding: 0;
  }

  html {
    scroll-behavior: smooth;
  }

  body {
    margin: 0;
    font-family: ${theme.fonts.primary};
    font-size: ${theme.fontBaseSize}px;
  }
`;
